define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "lodash.debounce", "moment", "../../utils/MathUtil", "../domain", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, lodash_debounce_1, moment_1, MathUtil_1, domain_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TravelPermit = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    moment_1 = tslib_1.__importDefault(moment_1);
    class TravelPermit extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "PermitId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TravelType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TravelTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TravelSpeed", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TravelSpeedError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TravelDistance", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TravelDistanceError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TravelSegmentType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TravelSegmentTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartTime", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StartTimeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndTime", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EndTimeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChargeableDays", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChargeableDaysError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalStartDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalStartDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalStartTime", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalStartTimeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalEndDt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalEndDtError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalEndTime", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalEndTimeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalChargeableDays", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalChargeableDaysError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalTravelSpeed", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalTravelSpeedError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DroverId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DroverIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DroverCount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DroverCountError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HealthCertNo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HealthCertNoError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Pic", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PicError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaybillNo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaybillNoError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockBrand", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockBrandError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OriginName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OriginNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DestinationName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DestinationNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Permit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onChangeBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, TravelPermit.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Permit = parent;
            this.PermitId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Permit = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.PermitId = (0, EntityUtil_1.toInt)(entity.PermitId);
            a.TravelType = (0, EntityUtil_1.toInt)(entity.TravelType);
            a.TravelSpeed = (0, EntityUtil_1.toFloat)(entity.TravelSpeed);
            a.TravelDistance = (0, EntityUtil_1.toFloat)(entity.TravelDistance);
            a.TravelSegmentType = (0, EntityUtil_1.toInt)(entity.TravelSegmentType);
            a.StartDt = b.StartDt;
            a.StartTime = b.StartTime;
            a.EndDt = b.EndDt;
            a.EndTime = b.EndTime;
            a.ChargeableDays = (0, EntityUtil_1.toInt)(entity.ChargeableDays);
            a.FinalStartDt = b.FinalStartDt;
            a.FinalStartTime = b.FinalStartTime;
            a.FinalEndDt = b.FinalEndDt;
            a.FinalEndTime = b.FinalEndTime;
            a.FinalChargeableDays = (0, EntityUtil_1.toInt)(entity.FinalChargeableDays);
            a.FinalTravelSpeed = (0, EntityUtil_1.toFloat)(entity.FinalTravelSpeed);
            a.DroverId = (0, EntityUtil_1.toInt)(entity.DroverId);
            a.DroverCount = (0, EntityUtil_1.toInt)(entity.DroverCount);
            a.HealthCertNo = b.HealthCertNo;
            a.Pic = b.Pic;
            a.WaybillNo = b.WaybillNo;
            a.StockBrand = b.StockBrand;
            a.OriginName = b.OriginName;
            a.DestinationName = b.DestinationName;
            a.Shape = (0, EntityUtil_1.mergePolyline)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.onChangeBatchFn = (0, lodash_debounce_1.default)(this.onChange, 500);
            this.addChangeEventAction("StartDt", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("StartTime", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("EndDt", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("EndTime", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("FinalStartDt", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("FinalStartTime", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("FinalEndDt", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("FinalEndTime", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("TravelSpeed", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("TravelType", this.onChangeBatchFn.bind(this));
            this.addChangeEventAction("TravelDistance", this.onChangeBatchFn.bind(this));
            if (this.Permit) {
                this.Permit.addChangeEventAction("FeeApplicationRule", this.onChangeBatchFn.bind(this));
                this.Permit.addChangeEventAction("FeePermitRule", this.onChangeBatchFn.bind(this));
            }
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, TravelPermit.AliasName);
            this.reset();
            if (!this.IsMarkedForDeletion && this.Permit.IsActive) {
                if (!this.TravelSpeed) {
                    this.TravelSpeedError = "Travel speed required";
                    validationState.addError(this.TravelSpeedError);
                }
                else if (this.TravelType == domain_1.TravelTypeDomain.SlowTravel && (this.TravelSpeed < 5 || this.TravelSpeed >= 10)) {
                    this.TravelSpeedError = "Travel speed must be between 5 & 10";
                    validationState.addError(this.TravelSpeedError);
                }
                else if (this.TravelType == domain_1.TravelTypeDomain.NormalTravel && (this.TravelSpeed < 10 || this.TravelSpeed > 30)) {
                    this.TravelSpeedError = "Travel speed must be between 10 & 30";
                    validationState.addError(this.TravelSpeedError);
                }
                if (this.Permit.License.IsPendingApprovalOrApproved) {
                    this._validate(validationState, recurseChildren);
                    if (this.StartDt > this.EndDt) {
                        this.StartDtError = "Permit end date must not preceed its start date";
                        validationState.addError(this.StartDtError);
                    }
                    else {
                        this.StartDtError = "";
                    }
                    if (this.FinalStartDt > this.FinalEndDt) {
                        this.FinalStartDtError = "Actual Permit end date must not preceed its actual start date";
                        validationState.addError(this.FinalStartDtError);
                    }
                    else {
                        this.FinalStartDtError = "";
                    }
                    if (this.Permit.License.IsPendingApprovalOrApproved) {
                        if (isNaN(this.DroverId) || this.DroverId <= 0) {
                            this.DroverIdError = "A Primary Drover must be specified";
                            validationState.addError(this.DroverIdError);
                        }
                        else {
                            this.DroverIdError = "";
                        }
                        if (isNaN(this.DroverCount) || this.DroverCount <= 0) {
                            this.DroverCountError = "Invalid Drover Count specified";
                            validationState.addError(this.DroverCountError);
                        }
                        else {
                            this.DroverCountError = "";
                        }
                    }
                }
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "PermitId", "Permit ID");
                this.validateReqNumber(validationState, "DroverId", "Drover Id");
                this.validateReqNumber(validationState, "DroverCount", "No Of Drovers");
                this.validateReqString(validationState, "Pic", "PIC of Originating Property");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                PermitId: this.PermitId,
                TravelType: this.TravelType,
                TravelSpeed: this.TravelSpeed,
                TravelDistance: this.TravelDistance,
                TravelSegmentType: this.TravelSegmentType,
                StartDt: this.StartDt,
                StartTime: this.StartTime,
                EndDt: this.EndDt,
                EndTime: this.EndTime,
                ChargeableDays: this.ChargeableDays,
                FinalStartDt: this.FinalStartDt,
                FinalStartTime: this.FinalStartTime,
                FinalEndDt: this.FinalEndDt,
                FinalEndTime: this.FinalEndTime,
                FinalChargeableDays: this.FinalChargeableDays,
                FinalTravelSpeed: this.FinalTravelSpeed,
                DroverId: this.DroverId,
                DroverCount: this.DroverCount,
                HealthCertNo: this.HealthCertNo,
                Pic: this.Pic,
                WaybillNo: this.WaybillNo,
                StockBrand: this.StockBrand,
                OriginName: this.OriginName,
                DestinationName: this.DestinationName,
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get ApplicableTravelTypes() {
            var result = new domain_1.DynamicDomain();
            switch (this.TravelType) {
                case domain_1.TravelTypeDomain.UnfitStockGrazing:
                    result.add(domain_1.TravelTypeDomain.findByKey(domain_1.TravelTypeDomain.UnfitStockGrazing));
                    break;
                case domain_1.TravelTypeDomain.UnfitStockTravel:
                    result.add(domain_1.TravelTypeDomain.findByKey(domain_1.TravelTypeDomain.NormalTravel));
                    result.add(domain_1.TravelTypeDomain.findByKey(domain_1.TravelTypeDomain.SlowTravel));
                    result.add(domain_1.TravelTypeDomain.findByKey(domain_1.TravelTypeDomain.UnfitStockTravel));
                    break;
                default:
                    result.add(domain_1.TravelTypeDomain.findByKey(domain_1.TravelTypeDomain.NormalTravel));
                    result.add(domain_1.TravelTypeDomain.findByKey(domain_1.TravelTypeDomain.SlowTravel));
                    break;
            }
            return result;
        }
        onChange(change) {
            if (this.Permit) {
                this.disableChangeObserver();
                this.calculateDates(change);
                this.calculateFees();
                this.validate(true);
                this.enableChangeObserver();
            }
        }
        calculateDates(change) {
            if (!change) {
                return;
            }
            const calculateTravelSpeed = (days, distance) => {
                const travelSpeed = days <= 1
                    ? distance
                    : distance / days;
                return (0, MathUtil_1.round)(travelSpeed, 2);
            };
            if (this.Permit.LicenseStatus == domain_1.PermitLicenseStatusDomain.Draft) {
                if (change.name == "TravelType" || change.name == "TravelDistance" || change.name == "TravelSpeed") {
                    if (change.name == "TravelType") {
                        this.TravelSpeed = services_1.AppConfigManager.InstanceSync.getTravelSpeedRule(this.Permit, this.TravelType).DefaultSpeed;
                        this.FinalTravelSpeed = this.TravelSpeed;
                    }
                    if (change.name == "TravelSpeed") {
                        this.FinalTravelSpeed = this.TravelSpeed;
                    }
                    var travelDays = Math.round(this.TravelDistance / this.TravelSpeed);
                    this.EndDt = (0, moment_1.default)(this.StartDt).add(travelDays, "days").valueOf();
                    this.FinalEndDt = this.EndDt;
                    this.ChargeableDays = TravelPermit.daysDiff(this.StartDt, this.StartTime, this.EndDt, this.EndTime);
                    this.FinalChargeableDays = this.ChargeableDays;
                }
                else if (change.name == "StartDt") {
                    this.EndDt = (0, moment_1.default)(this.StartDt).add(this.ChargeableDays, "days").valueOf();
                    this.FinalEndDt = this.EndDt;
                    this.FinalStartDt = this.StartDt;
                }
                else if (change.name == "StartTime") {
                    this.EndTime = this.StartTime;
                    var travelDays = TravelPermit.daysDiff(this.StartDt, this.StartTime, this.EndDt, this.EndTime);
                    if (travelDays > this.ChargeableDays) {
                        this.ChargeableDays = travelDays;
                        this.FinalChargeableDays = this.ChargeableDays;
                        this.EndDt = (0, moment_1.default)(this.StartDt).add(this.ChargeableDays, "days").valueOf();
                    }
                    else if (travelDays < this.ChargeableDays) {
                        this.ChargeableDays = travelDays;
                        this.FinalChargeableDays = this.ChargeableDays;
                        this.EndDt = (0, moment_1.default)(this.StartDt).add(this.ChargeableDays, "days").valueOf();
                    }
                    this.FinalStartDt = this.StartDt;
                    this.FinalStartTime = this.StartTime;
                    this.FinalEndDt = this.EndDt;
                    this.FinalEndTime = this.EndTime;
                }
                else if (change.name == "EndDt" || change.name == "EndTime") {
                    const travelDays = TravelPermit.daysDiff(this.StartDt, this.StartTime, this.EndDt, this.EndTime);
                    this.TravelSpeed = calculateTravelSpeed(travelDays, this.TravelDistance);
                    this.FinalTravelSpeed = this.TravelSpeed;
                    this.ChargeableDays = travelDays;
                    this.FinalChargeableDays = this.ChargeableDays;
                    this.FinalEndDt = this.EndDt;
                    this.FinalEndTime = this.EndTime;
                }
            }
            else if (change.name == "FinalStartDt" || change.name == "FinalStartTime" || change.name == "FinalEndDt" || change.name == "FinalEndTime") {
                this.FinalChargeableDays = TravelPermit.daysDiff(this.FinalStartDt, this.FinalStartTime, this.FinalEndDt, this.FinalEndTime);
                this.FinalTravelSpeed = calculateTravelSpeed(this.FinalChargeableDays, this.TravelDistance);
            }
        }
        calculateFees() {
            (0, EventManager_1.notify)("Calculating Fees");
            services_1.SrmsServiceManager.Instance.PermitApplication.calculateTravelPermitFees(this.Permit.toJson()).then(res => {
                if (res) {
                    this.Permit.FeeApplication = res.FeeApplication;
                    this.Permit.FeePermit = res.FeePermit;
                    this.Permit.FeeTotal = res.FeeTotal;
                    this.Permit.FeeStateGov = res.FeeStateGov;
                    this.Permit.FinalFeeTotal = res.FinalFeeTotal;
                    this.Permit.FinalFeeStateGov = res.FinalFeeStateGov;
                }
            });
        }
        static daysDiff(startDate, startTime, endDate, endTime) {
            if (startDate == endDate) {
                return 0;
            }
            else {
                let days = (0, moment_1.default)(endDate).diff((0, moment_1.default)(startDate), "days");
                if (days == 1) {
                    if (startTime == domain_1.TimeOfDayDomain.Am && endTime == domain_1.TimeOfDayDomain.Pm) {
                        return days + 1;
                    }
                    else {
                        return days;
                    }
                }
                else {
                    if (startTime == domain_1.TimeOfDayDomain.Am && endTime == domain_1.TimeOfDayDomain.Pm) {
                        return days + 1;
                    }
                    else if (startTime == domain_1.TimeOfDayDomain.Pm && endTime == domain_1.TimeOfDayDomain.Am) {
                        return days - 1;
                    }
                    else {
                        return days;
                    }
                }
            }
        }
    }
    exports.TravelPermit = TravelPermit;
    Object.defineProperty(TravelPermit, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "TravelPermit"
    });
    Object.defineProperty(TravelPermit, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Travel Permit"
    });
    Object.defineProperty(TravelPermit, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "PermitId", "TravelType", "TravelSpeed", "TravelDistance", "TravelSegmentType", "StartDt", "StartTime", "EndDt", "EndTime", "ChargeableDays", "FinalStartDt", "FinalStartTime", "FinalEndDt", "FinalEndTime", "FinalChargeableDays", "FinalTravelSpeed", "DroverId", "DroverCount", "HealthCertNo", "Pic", "WaybillNo", "StockBrand", "OriginName", "DestinationName", "Shape"]
    });
    Object.defineProperty(TravelPermit, "PermitIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(TravelPermit, "TravelTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(TravelPermit, "TravelTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "TravelSpeedReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "TravelDistanceReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "TravelSegmentTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(TravelPermit, "TravelSegmentTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "StartDtTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the expected start date of the travel"
    });
    Object.defineProperty(TravelPermit, "StartDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "StartTimeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(TravelPermit, "StartTimeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Is travel expected to commence in the morning or afternoon?"
    });
    Object.defineProperty(TravelPermit, "StartTimeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(TravelPermit, "StartTimeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "EndDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "EndTimeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(TravelPermit, "EndTimeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(TravelPermit, "EndTimeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "ChargeableDaysReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "FinalStartDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "FinalStartTimeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(TravelPermit, "FinalStartTimeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(TravelPermit, "FinalStartTimeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "FinalEndDtTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the date that the travel was completed"
    });
    Object.defineProperty(TravelPermit, "FinalEndDtReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "FinalEndTimeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(TravelPermit, "FinalEndTimeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Did the travel finish in the morning or afternoon?"
    });
    Object.defineProperty(TravelPermit, "FinalEndTimeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(TravelPermit, "FinalEndTimeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "FinalChargeableDaysReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "FinalTravelSpeedReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "DroverIdTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Which drover is in charge of the travelling stock for the permit commencing in this local area?"
    });
    Object.defineProperty(TravelPermit, "DroverIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(TravelPermit, "DroverCountTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "How many persons are in control of the travelling stock for the permit commencing in this local area?"
    });
    Object.defineProperty(TravelPermit, "DroverCountReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(TravelPermit, "HealthCertNoLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(TravelPermit, "HealthCertNoTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter a Health Certificate Number if interstate travel is involved"
    });
    Object.defineProperty(TravelPermit, "HealthCertNoReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "PicLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 200
    });
    Object.defineProperty(TravelPermit, "PicTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Property Identification Code of originating property"
    });
    Object.defineProperty(TravelPermit, "PicReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(TravelPermit, "WaybillNoLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 200
    });
    Object.defineProperty(TravelPermit, "WaybillNoReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "StockBrandLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 256
    });
    Object.defineProperty(TravelPermit, "StockBrandReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "OriginNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 200
    });
    Object.defineProperty(TravelPermit, "OriginNameTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What place name best describes the origin of travel?"
    });
    Object.defineProperty(TravelPermit, "OriginNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(TravelPermit, "DestinationNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 200
    });
    Object.defineProperty(TravelPermit, "DestinationNameTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What place name best describes the travel destination?"
    });
    Object.defineProperty(TravelPermit, "DestinationNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "PermitId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "PermitIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "TravelType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "TravelTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "TravelSpeed", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "TravelSpeedError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "TravelDistance", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "TravelDistanceError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "TravelSegmentType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "TravelSegmentTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "StartDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "StartDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "StartTime", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "StartTimeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "EndDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "EndDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "EndTime", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "EndTimeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "ChargeableDays", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "ChargeableDaysError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalStartDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalStartDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalStartTime", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalStartTimeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalEndDt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalEndDtError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalEndTime", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalEndTimeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalChargeableDays", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalChargeableDaysError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalTravelSpeed", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "FinalTravelSpeedError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "DroverId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "DroverIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "DroverCount", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "DroverCountError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "HealthCertNo", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "HealthCertNoError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "Pic", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "PicError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "WaybillNo", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "WaybillNoError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "StockBrand", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "StockBrandError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "OriginName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "OriginNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "DestinationName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "DestinationNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TravelPermit.prototype, "Permit", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], TravelPermit.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TravelPermit.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TravelPermit.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TravelPermit.prototype, "ApplicableTravelTypes", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TravelPermit.prototype, "onChange", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TravelPermit.prototype, "calculateDates", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TravelPermit.prototype, "calculateFees", null);
});
